import { render, staticRenderFns } from "./SuccessIcon.vue?vue&type=template&id=8020d1e6&scoped=true"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8020d1e6",
  null
  
)

export default component.exports